<input
    class="channel-input-wrapper"
    [class.hasError]="hasError"
    (focus)="isFocused = true; filterList()"
    (blur)="isFocused = false; checkError()"
    [(ngModel)]="inputValue"
    (input)="filterList()"
    [placeholder]="'channel-search.input.placeholder' | translate" />
<ng-container *ngIf="isFocused">
    <div class="channel-search-container" (mousedown)="$event.preventDefault()">
        <div class="search-container-wrapper">
            <div *ngFor="let channel of filteredChannels" class="filtered-channel" (click)="selectChannel(channel)">
                <div class="channel-name" [innerHTML]="getChannelName(channel) | highlight: inputValue"></div>
            </div>

            <ng-container *ngIf="hasError">
                <div class="no-results-text">
                    {{ 'channel-search.input.no-results' | translate }}
                </div></ng-container
            >
        </div>
        <div class="padding-container"></div>
    </div>
</ng-container>
